import { render, staticRenderFns } from "./selectPubMan.vue?vue&type=template&id=886e805e&scoped=true"
import script from "./selectPubMan.vue?vue&type=script&lang=js"
export * from "./selectPubMan.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=886e805e&prod&scoped=true&lang=css&external"
import style1 from "./selectPubMan.vue?vue&type=style&index=1&id=886e805e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886e805e",
  null
  
)

export default component.exports